import React from 'react';
import {
  Button,
  //Col,
  Drawer,
  DrawerProps,
  Row,
  Table,
} from 'antd';
import { CloseOutlined, SearchOutlined } from '@ant-design/icons';
import moment from 'moment';
import { SmartScannerInput, SmartSpace } from 'components/Sales/Smart/SmartComponent';
import { Label, SecondaryButton, message } from 'components/common';
import {
  COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
  //COMMON_MSG_DEFAULT_DISPLAY_DURATION,
  DEFAULT_DATE_FORMAT,
  //HTTP_STATUS_OK,
} from 'constants/config';
import { fetchWarehouseTransferList } from 'services/inventory';
import { WHTActionType as WHTAction } from './context';

type Props = ReduxStateProps & DrawerProps & {
  //items: StringKAnyVPair[];
  onSelect?: Function;
};

const BatchSelectorDrawer = (props: Props) => {
  //const DATE_SEARCH_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSS';
  //const DEFAULT_GRID_PAGE_SIZE = 20;
  const { useRef, useState } = React;

  const [batchList, setBatchList] = useState<StringKAnyVPair[]>([]);

  //const gridPageIndex = useRef<number>(0);
  //const gridPageSize = useRef<number>(DEFAULT_GRID_PAGE_SIZE);
  const searchBatchCode = useRef<string>('');

  const columns = [
    {
      title: 'Batch #',
      dataIndex: 'batchNumber',
    },
    {
      title: 'Create Date',
      dataIndex: 'createDate',
      render(dt: string) {
        return moment(dt).format(DEFAULT_DATE_FORMAT);
      },
    },
  ];

  const drawerFooter = () => {
    return (
      <Row justify="center">
        <SecondaryButton
          onClick={onClose}
          size="large"
          style={{maxWidth: 250, width: '100%', height: 50}}
        >
          <CloseOutlined />
          Close
        </SecondaryButton>
        {/*<Col span={12} style={{paddingLeft: 5}}>
          <Button
            disabled={!isSavable()}
            onClick={onSave}
            size="large"
            style={{width: '100%'}}
            type="primary"
          >
            <SaveOutlined />
            Save
          </Button>
        </Col>*/}
      </Row>
    );
  };

  const listRowProps = (row: StringKAnyVPair) => ({
    onClick: () => onRowClick(row),
    /*style: {
      backgroundColor: row.poStatusNum === 2 ? '#FFFBE6' : undefined,
    },*/
  });

  const onRowClick = (record: StringKAnyVPair) => {
    console.log('re', record);
    if (props.onSelect) props.onSelect(record);
    // @ts-ignore
    onClose();
  };

  const onSearch = async (lotStr?: string) => {
    const { dispatch, state } = props;
    const bnStr = lotStr === undefined ? searchBatchCode.current : lotStr.trim();

    //console.log('s', bnStr);
    dispatch({ type: WHTAction.SetLockScreen, params: true });
    try {
      const params = {
        $skip: 0,
        $top: 100,
        //transferStatus: ,
        //statusList: [0, 1],
        statusList: '[0, 1]',
        transferType: 0,
        $sortBy: 'TransferNum desc',
        batchNumber: bnStr,
      };

      const { /*count,*/ data } = await fetchWarehouseTransferList(
        state.selectedWarehouse.warehouseId,
        params,
      );
      //const res: StringKAnyVPair = {total: 0, data: []};

      //console.log('res', data);
      if (Array.isArray(data)) {
        //setGridCount(res.total);
        setBatchList(data);
      } else {
        //clearBatchGrid();
      }
    } catch(e) {
      message.error({
        content: `Fetched batch # list error: ${e}`,
        duration: COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
      });
    } finally {
      dispatch({ type: WHTAction.SetLockScreen, params: false });
    }
  };

  const onSearchBatchChange = (evt: any) => {
    const bnStr = evt.target.value.trim();
    //console.log('ch', lotCode);
    searchBatchCode.current = bnStr;
  };

  const searchBatchButton = () => {
    return (
      <Button
        className="addon-btn-after"
        onClick={() => onSearch()}
        type="primary"
      >
        <SearchOutlined />
      </Button>
    );
  };

  const onClose = (evt: any) => {
    if (props.onClose) props.onClose(evt);
  };

  const tableScrollHeight = () => {
    return window.innerHeight - 299;
  };

  return (<>
    <Drawer
      bodyStyle={{ padding: 10 }}
      closable={false}
      footer={drawerFooter()}
      footerStyle={{ padding: 10 }}
      onClose={onClose}
      placement="bottom"
      visible={props.visible}
      width={window.innerWidth}
      height={window.innerHeight - 56}
    >
      <SmartSpace className="mb-0">
        <Row>
          <Label theme={{fontSize: '1.3em'}}>Select Batch # from list</Label>
        </Row>
        <div className="b-b-bordered mb-10 mt-10" />
        <Row align="middle" justify="space-between">
          {/*<Label className="label-bold tail-colon1" theme={{fontSize: '1.3em'}}>Batch#</Label>*/}
          <SmartScannerInput
            addonAfter={searchBatchButton()}
            allowClear
            className="fs-24 h-50"
            //defaultValue={currentLotCode}
            onChange={onSearchBatchChange}
            onScan={onSearch}
            placeholder="Input Batch# here"
            //style={{width: 'calc(100% - 72px)'}}
          />
        </Row>
        {batchList.length > 0 && (
          <Table
            className="mt-10"
            columns={columns}
            dataSource={batchList}
            onRow={listRowProps}
            pagination={false}
            rowKey="batchNumber"
            scroll={{y: tableScrollHeight()}}
            size="middle"
          />
        )}
      </SmartSpace>
    </Drawer>
  </>);
};

export default BatchSelectorDrawer;
